import { memo, useContext } from "react";
import Skeleton from "react-loading-skeleton";
import "./QuotationSkeleton.scss";
import appGlobalsContext from "app/AppGlobalsContext";

const SKELETON_HIGHLIGHT_COLOR = "#cdcdcd";

const FlightsAndOptionsSkeleton = () => {
	const { publicPath = "" } = useContext(appGlobalsContext);
	return (
		<div className="skeleton-quote">
			<div className="skeleton-quote__head flight">
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={20}
					borderRadius={15}
					width={400}
					containerClassName="skeleton-quote__head-skeleton skeleton"
				/>
			</div>
			<div className="skeleton-quote__file">
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					baseColor="#DDDDDD"
					className="skeleton-quote__file-skeleton"
				/>
			</div>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={20}
				borderRadius={15}
				containerClassName="skeleton-section"
			/>
			<img src={`${publicPath}/icons/quote-flight-class.png`} className="skeleton-section" />
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={200}
				borderRadius={15}
				containerClassName="skeleton-section"
			/>
			<br />
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={20}
				borderRadius={15}
				containerClassName="skeleton-section skeleton-quote__block"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={80}
				borderRadius={10}
				containerClassName="skeleton-section skeleton-last skeleton-quote__block"
			/>
		</div>
	);
};

FlightsAndOptionsSkeleton.propTypes = {};

export default memo(FlightsAndOptionsSkeleton);
